<script lang="ts">
	import captureClick from '$lib/actions/captureClick';
	import type { SbLink } from '$lib/storyblok/types';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import type { ISbStoryData } from '@storyblok/js';

	interface Props {
		content: ISbStoryData<{
			label: string;
			link: SbLink;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<a
	href={getSbUrl(content.link)}
	use:captureClick
	class="text-[36px]/[112%] tracking-[-.36px] transition-transform duration-300 max-lg:py-2 lg:hover:translate-x-2"
>
	{content.label}
</a>
